export enum MoreOperateKey {
  MEET = 'meet',
  MESSAGES = 'messages',
  PARTICIPANTS = 'participants',
  FULL_SCREEN = 'fullScreen',
  SETTING = 'setting',
}

export interface MoreOperateProps {
  children: React.ReactNode;
  onClick: (value: string) => void;
}
